// Trust top-ranked result; callers handle partial_match
export function selectBestResult(results) {
    if (!Array.isArray(results) || results.length === 0) return null;
    return results[0];
}

// Country short_name, or ''
export function findCountryShortName(components = []) {
    const country = (components || []).find((c) => c.types.includes('country'));
    return country?.short_name || '';
}

// Non-US guard
export function isNonUsResult(result) {
    const code = findCountryShortName(result?.address_components || []);
    return !!code && !['US', 'USA'].includes(code);
}
